<template>
<div class="wrapper">
  <div class="container details">
    <div class="row">
      <div class="col-md-12">
        <h1>Skapa ny internorder</h1>
      </div>
    </div>
    <div class="row internOrderDetailsWrapper">
      <div class="col-md-12">
        <form class="formGeneratorWithColumns feralcoOrderDetailsActiveWrapper">
          <vue-form-generator tag="div" :schema="activeSchema" :model="orderModel" @model-updated="onModelUpdated" />
        </form>
      </div>
    </div>
  </div>
  <div class="orderButtonsWrapper container">
    <div class="row">
      <div class="col-md-12">
        <SplitButton label="Skapa" class="p-button-success" :model="saveButtons" @click="onSave(currentOrder)" icon="pi pi-check" ></SplitButton>
        <Button label="Tillbaka" @click="onCancel()"/>
      </div>
    </div>
  </div>
   <Toast :position="toastPosition" />
</div>
</template>

<script>
import VueFormGenerator from 'vue-form-generator'
import Map from '@/components/Map/Map'
import Button from 'primevue/button'
import SplitButton from 'primevue/splitbutton'
import Toast from 'primevue/toast'
export default {
  name: 'OrderCreate',
  components: {
    'vue-form-generator': VueFormGenerator.component,
    Map,
    Toast,
    Button,
    SplitButton
  },
  data () {
    return {
      schema: {},
      orderModel: {},
      activeSchema: {},
      drivers: null,
      saveButtons: [
        {
          label: 'Skicka till lastbil',
          icon: 'pi pi-user',
          command: () => {
            this.onCreateAndSend()
          }
        }
      ],
      toastPosition: 'topright'
    }
  },
  mounted () {
    this.schema = this.$route.params.schema
    this.activeInputs()
    this.getDrivers()
    this.getTrucks()
    this.getTrailers()
    this.orderModel.quantity = '40'
    this.orderModel.productId = 'Saltsyra 34%'
  },
  methods: {
    onModelUpdated (newVal, schema) {
      if (schema === 'driverLoading') {
        this.orderModel.driverDelivering = newVal
        let driver = this.drivers.find(x => x.id === newVal)
        if (driver.truckId !== null) {
          this.orderModel.truck = driver.truckId
        }
        if (driver.trailerId !== null) {
          this.orderModel.trailer = driver.trailerId
        }
        this.checkPermission(driver)
      } else if (schema === 'driverDelivering' || schema === 'trailerDriverName') {
        let driver = this.drivers.find(x => x.id === newVal)
        this.checkPermission(driver)
      }
    },
    activeInputs () {
      this.activeSchema = Object.assign({}, this.schema)
      this.activeSchema.groups = this.activeSchema.groups.filter((c) => c.activeInDetails)
    },
    getDrivers () {
      var driverLoadingSelect = this.activeSchema.groups[1].fields.find(field => field.model === 'driverLoading')
      var driverDeliveringSelect = this.activeSchema.groups[1].fields.find(field => field.model === 'driverDelivering')
      var trailerDriverDeliveringSelect = this.activeSchema.groups[5].fields.find(field => field.model === 'trailerDriverName')
      this.$http
        .get('/api/users/drivers')
        .then(response => {
          var users = response.data
          this.drivers = response.data
          for (var i = 0; i < users.length; i++) {
            if (users[i].permissionADRTank === 'Ja' && users[i].inActive !== 'Ja') {
              driverLoadingSelect.values.push({'id': users[i].id, 'name': users[i].firstName + ' ' + users[i].lastName})
              driverDeliveringSelect.values.push({'id': users[i].id, 'name': users[i].firstName + ' ' + users[i].lastName})
              trailerDriverDeliveringSelect.values.push({'id': users[i].id, 'name': users[i].firstName + ' ' + users[i].lastName})
            }
          }
        })
        .catch(error => console.log(error))
    },
    getTrucks () {
      var trucksSelect = this.activeSchema.groups[1].fields.find(field => field.model === 'truck')
      this.$http
        .get('/api/objectdatas/objectdescriptionid/5')
        .then(response => {
          var trucks = response.data
          for (var i = 0; i < trucks.length; i++) {
            trucksSelect.values.push({'id': trucks[i].id, 'name': trucks[i].data.regnbr, 'type': trucks[i].ObjectDescription.name})
          }
        })
        .catch(error => console.log(error))
    },
    getTrailers () {
      var trailersSelect = this.activeSchema.groups[1].fields.find(field => field.model === 'trailer')
      this.$http
        .get('/api/objectdatas/objectdescriptionid/8')
        .then(response => {
          var trailers = response.data
          for (var i = 0; i < trailers.length; i++) {
            trailersSelect.values.push({'id': trailers[i].id, 'name': trailers[i].data.regnbr})
          }
        })
        .catch(error => console.log(error))
    },
    getGroupLoading () {
      this.$http
        .get('/api/orders/get-active/')
        .then(response => {
          var groupLoadingSelect = this.activeSchema.groups[6].fields.find(field => field.model === 'GroupLoading')
          for (var i = 0; i < response.data.values.length; i++) {
            groupLoadingSelect.values.push(response.data.values[i])
          }
        })
        .catch(error => console.log(error))
    },
    checkPermission (driver) {
      let loadingPlace = this.order.data.loadingPlaces
      let deliveryPlace = this.order.data.deliveryPlaces
      if ((loadingPlace === 'Kemira' && driver.permissionLoadAcidFromKemira !== 'Ja') ||
      (loadingPlace === 'Inovyn' && driver.permissionLoadAcidFromInovyn !== 'Ja') ||
      (loadingPlace === 'Vetlanda' && driver.permissionLoadProductFromVet !== 'Ja') ||
      (loadingPlace === 'Sölvesborg' && this.order.data.productId === 'SOL-P-FeCl3 314' && driver.permissionLoadProdFrSolE90 !== 'Ja')) {
        this.showNoPermission()
      }
      if ((deliveryPlace === 'Vetlanda' && driver.permissionUnloadProductInVet !== 'Ja') || (deliveryPlace === 'Sölvesborg' && driver.permissionUnloadProductInSol !== 'Ja')) {
        this.showNoPermission()
      }
    },
    showNoPermission () {
      this.toastPosition = 'center'
      this.$toast.add({severity: 'warn', summary: 'Vald chaufför har inte rätt behörighet', life: 3000000})
    },
    onSave () {
      if (this.orderModel.dateDelivery) {
        this.orderModel.dateDelivery = new Date(Date.UTC(this.orderModel.dateDelivery.getFullYear(), this.orderModel.dateDelivery.getMonth(), this.orderModel.dateDelivery.getDate()))
      }
      if (this.orderModel.dateBooking) {
        this.orderModel.dateBooking = new Date(Date.UTC(this.orderModel.dateBooking.getFullYear(), this.orderModel.dateBooking.getMonth(), this.orderModel.dateBooking.getDate()))
      }
      var url = '/api/orders'
      this.orderModel.kund = 1
      this.orderModel.quantity = this.orderModel.quantity.replace(',', '.')
      this.$http
        .post(url, {
          order: {
            type: 'feralcoIntern',
            state: 'redo',
            needsAttention: 0,
            data: this._.omit(this.orderModel, 'submit')
          }
        })
        .then(response => {
          this.$router.go(-1)
        })
        .catch(error => console.log(error))
    },
    onCreateAndSend () {
      if (this.orderModel.dateDelivery) {
        this.orderModel.dateDelivery = new Date(Date.UTC(this.orderModel.dateDelivery.getFullYear(), this.orderModel.dateDelivery.getMonth(), this.orderModel.dateDelivery.getDate()))
      }
      if (this.orderModel.dateBooking) {
        this.orderModel.dateBooking = new Date(Date.UTC(this.orderModel.dateBooking.getFullYear(), this.orderModel.dateBooking.getMonth(), this.orderModel.dateBooking.getDate()))
      }
      var url = '/api/orders'
      this.orderModel.kund = 1
      this.orderModel.quantity = this.orderModel.quantity.replace(',', '.')
      this.$http
        .post(url, {
          order: {
            type: 'feralcoIntern',
            state: 'redo',
            needsAttention: 0,
            data: this._.omit(this.orderModel, 'submit')
          }
        })
        .then(response => {
          var url = '/api/orders/' + response.data.id
          this.$http
            .put(url, {
              order: {
                id: response.data.id,
                state: 'skickad',
                data: this._.omit(response.data.data, 'submit')
              }
            })
            .then(response => {
              this.$router.go(-1)
            })
            .catch(error => console.log(error))
        })
        .catch(error => console.log(error))
    },
    onDelete () {
      let message = 'Är du säker?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          var url = '/api/orders/' + this.order.id
          this.$http
            .delete(url)
            .then(response => {
              this.$router.go(-1)
            })
            .catch(error => console.log(error))
        })
        .catch(function () {
          console.log('Clicked on cancel')
        })
    },
    onCancel () {
      this.$router.go(-1)
    },
    onFinished () {
      this.$router.go(-1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Orders/FeralcoInternOrderCreate.vue